import { useQuery } from '@tanstack/react-query'
import { getAutoAcceptPatientMatchIndex } from '~/entities/document'
import { apiClient } from '~/shared/api/data-ingestion-api'

/**
 * Non-suspense resolver for the deterministic patient-match index, for callers
 * outside the patient-matching page (e.g. the tagging step deciding whether to
 * skip patient matching — PBDP-1412).
 *
 * Returns the index to auto-accept, or `null` when the step is not
 * deterministically matched, the query is disabled, or the data has not loaded
 * yet. A `null` result means "do not skip — fall back to manual review", which
 * is the safe default.
 */
export function useAutoAcceptPatientMatchIndex({
  documentKey,
  enabled,
}: {
  documentKey: string
  enabled: boolean
}): number | null {
  const { data } = useQuery({
    ...apiClient.getDocumentPatientMatchesDocumentsKeyPatientMatchesGetOptions({
      path: { key: documentKey },
    }),
    enabled,
  })

  if (!enabled || !data) {
    return null
  }

  return getAutoAcceptPatientMatchIndex({
    selectedMatchIndex: data.selected_match_index,
    feedbackStatus: data.feedback_status,
  })
}
